import React, { useState, useEffect } from 'react'
import { Environment } from 'enviroment/AppSettings'


const getIsMobile = (breakpoint?: number) => {
    if(breakpoint !== undefined){
        return window.innerWidth < breakpoint
    }
    else {
        return window.innerWidth < Environment.desktopBreakpoint
    }
}

export default function useIsMobile(breakpoint?: number) {
    const [isMobile, setIsMobile] = useState(getIsMobile)

    useEffect(() => {
        const onResize = () => {
            setIsMobile(getIsMobile(breakpoint))
        }

        window.addEventListener("resize", onResize)
    
        return () => {
            window.removeEventListener("resize", onResize)
        }
    }, [])
    
    return isMobile
}